// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_bry","cls2":"ProfileDropdown-cls2_dZh ProfileDropdown-cls1_bry"};